import { defaultTo } from 'lodash';
import {
  ILicenseTypeModel,
  IModel,
  IPhotoModel,
  IStateModel,
  LicenseTypeModel,
  Model,
  PhotoModel,
  StateModel,
} from '.';

export interface ILicenseModel extends IModel {
  licenseId: number;
  number: string;
  expirationDate: string;
  isReadOnly: boolean;
  state: IStateModel;
  licenseType: ILicenseTypeModel;
  licensePhoto: IPhotoModel | undefined;
  readonly licenseStatus: string;
}

export class LicenseModel extends Model implements ILicenseModel {
  licenseId: number;
  number: string;
  expirationDate: string;
  isReadOnly: boolean;
  state: IStateModel;
  licenseType: ILicenseTypeModel;
  licensePhoto: IPhotoModel | undefined;

  constructor(params: Partial<ILicenseModel>) {
    super(params);
    this.licenseId = defaultTo(params?.licenseId, 0);
    this.number = defaultTo(params?.number, '0');
    this.expirationDate = defaultTo(params?.expirationDate, '');
    this.isReadOnly = defaultTo(params?.isReadOnly, false);
    this.state = new StateModel(params?.state);
    this.licenseType = new LicenseTypeModel(params?.licenseType);
    this.licensePhoto = params?.licensePhoto
      ? new PhotoModel(params?.licensePhoto)
      : undefined;
  }

  get licenseStatus(): string {
    const now = new Date(); // current time (local time, though expirationDate should be in a compatible format)
    const expDate = new Date(this.expirationDate);
    const diffMs = expDate.getTime() - now.getTime(); // difference in milliseconds
    const oneDayMs = 24 * 60 * 60 * 1000; // milliseconds in one day

    if (diffMs < -1 * oneDayMs) {
      //if expired more than 1 day ago from UTC now
      return 'Expired';
    }

    if (diffMs >= -1 * oneDayMs && diffMs <= oneDayMs) {
      //expiring with 2 day windows around UTC now
      return 'Expiring';
    }

    return 'Active';
  }
}
